import React, { ComponentType, SVGProps } from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../constants/Theme';
import LoadingSpinner from './LoadingSpinner';

interface TextlinkProps {
  title: string;
  onClick: () => void;
  underline?: boolean;
  iconRight?: ComponentType<SVGProps<any>>;
  fontSize?: number;
  loading?: boolean;
}

const Textlink: React.FC<TextlinkProps> = ({
  title,
  onClick,
  underline = false,
  iconRight: IconRight,
  fontSize = 12,
  loading = false,
}) => {
  const classes = useStyles({ underline, fontSize });

  return (
    <button type="button" className={classes.container} onClick={onClick} disabled={loading}>
      {loading ? (
        <div className={classes.spinnerContainer}>
          <LoadingSpinner size={fontSize} color={theme.colors.roseMain} borderColor={theme.colors.blueLight} />
        </div>
      ) : (
        <>
          <span className={classes.title}>{title}</span>
          {IconRight && (
            <span className={classes.icon}>
              <IconRight />
            </span>
          )}
        </>
      )}
    </button>
  );
};

type useStyleProps = {
  underline: boolean;
  fontSize: number;
};

const useStyles = createUseStyles({
  container: (props: useStyleProps) => ({
    display: 'inline-flex',
    width: 'fit-content',
    background: 'none',
    border: 'none',
    padding: '0px 0px 2px 0px',
    color: theme.colors.roseMain,
    alignItems: 'center',
    borderBottom: props.underline ? `1px solid ${theme.colors.roseMain}` : 'none',
    '&:active': {
      color: theme.colors.functionalRed,
    },
    '&:disabled': {
      opacity: 0.7,
      cursor: 'not-allowed',
    },
  }),
  title: (props: useStyleProps) => ({
    fontSize: props.fontSize,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
  }),
  icon: {
    marginLeft: 4,
    display: 'flex',
  },
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Textlink;
